<template>
  <div class="bbr-settings--meal-guide-category">
    <main-app-bar>
      <template v-slot:title> Meal Guide Category Settings </template>
    </main-app-bar>

    <div class="mt-7 px-10 pb-6">
      <v-row>
        <v-col cols="5">
          <form autocomplete="off">
            <meal-guide-category-form :form-data="form" />
            <v-row>
              <v-col>
                <v-btn
                  class="bg-primary-gradient primary ml-auto mt-4"
                  depressed
                  @click="store"
                >
                  <v-icon class="mr-2">{{ icons.save }}</v-icon>
                  <span v-if="isNew">Save Settings</span>
                  <span v-else>Update Settings</span>
                </v-btn>
              </v-col>
              <v-col>
                <div class="text-right">
                  <v-btn
                    v-if="!isNew"
                    text
                    depressed
                    @click="clearForm"
                    class="mt-3"
                  >
                    Cancel
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-col>
        <v-col cols="7">
          <list-table
            :loading="loading"
            @edit="edit"
            :list="mealGuideCategories"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiContentSaveOutline, mdiCancel } from '@mdi/js'
import MainAppBar from '@/layouts/shared/MainAppBar'
import ListTable from './components/ListTable'
import MealGuideCategoryForm from './components/MealGuideCategoryForm'
import Form from '@/utils/form'

const emptyFields = {
  name: null,
  is_active: false,
  order: 0,
  icon: '',
}

export default {
  name: 'MealGuideCategorySettingsPage',

  components: {
    MainAppBar,
    ListTable,
    MealGuideCategoryForm,
  },

  data() {
    return {
      icons: { save: mdiContentSaveOutline, cancel: mdiCancel },
      loading: false,

      isNew: true,
      form: new Form(emptyFields),
    }
  },

  computed: {
    ...mapState({
      mealGuideCategories: (state) => state.mealGuideCategory.list,
    }),
  },

  created() {
    this.getMealGuideCategory({ search: null })
  },

  destroyed() {
    this.clearList()
  },

  methods: {
    ...mapActions({
      getMealGuideCategory: 'mealGuideCategory/getDataList',
      saveData: 'mealGuideCategory/saveData',
    }),

    ...mapMutations({
      clearList: 'mealGuideCategory/clearList',
    }),

    edit(row) {
      let payload = {
        id: row.id,
        name: row.name,
        is_active: row.is_active,
        order: row.order,
        icon: row.icon_info ? row.icon_info.public_id : null,
      }

      this.form = new Form(payload)
      this.isNew = false
    },

    clearForm() {
      this.form = new Form(emptyFields)
      this.isNew = true
    },

    store() {
      this.form.$busy = true
      this.form.$clearErrors()

      const payload = this.form.$data()

      this.saveData(payload)
        .then((data) => {
          this.form.$timeout(() => {
            this.form.$busy = false
            this.clearForm()
            this.getMealGuideCategory({ search: null })
          })
        })
        .catch((err) => {
          this.form.$timeout(() => {
            if (err.response && err.response.status === 422) {
              this.form.$setErrors(err.response.data.errors)
            }

            this.form.$busy = false
          })
        })
    },
  },
}
</script>
